/**
 * Employee Affiliates — same scaffold as AffiliatesPage but scoped to
 * referrer_type: 'employee'. No Candidates tab (employees are confirmed
 * via a different workflow). Mirrors legacy EmployeeAffiliateList.
 */
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Button, Tabs, TabsContent, TabsList, TabsTrigger } from '@vnetwork/ui/primitives';
import { AffiliateActiveListSection } from './components/affiliate-active-list-section';

const TABS = [
  { value: 'active', label: 'Active' },
] as const;

type TabValue = (typeof TABS)[number]['value'];

export default function EmployeeAffiliatesPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const urlTab = searchParams.get('tab') as TabValue | null;
  const activeTab: TabValue = TABS.some((t) => t.value === urlTab)
    ? (urlTab as TabValue)
    : 'active';

  const setTab = (value: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', value);
    setSearchParams(next, { replace: true });
  };

  return (
    <Container size="full">
      <PageHeader
        title="Employee Affiliates"
        description="Manage employee referral partners and track their commissions."
        actions={
          <Button startIcon={<Plus size={15} />} onClick={() => navigate('/affiliates/new')}>
            Add affiliate
          </Button>
        }
      />

      <Tabs value={activeTab} onValueChange={setTab}>
        <TabsList>
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="active">
          {activeTab === 'active' && (
            <AffiliateActiveListSection referrerType="employee" />
          )}
        </TabsContent>
      </Tabs>
    </Container>
  );
}
